module.exports = __webpack_public_path__ + "img/logoCTIRoads512x512.1d030a50.png";